import type React from 'react';
import { Card as RadixCard } from '@radix-ui/themes';
import { cn } from '@/lib/utils';
import { type RadixColors } from './RadixProps';

type BaseCardProps = React.ComponentProps<typeof RadixCard>;
type CardProps = Omit<BaseCardProps, 'variant'> & {
  variant?: 'accented' | BaseCardProps['variant'];
  color?: RadixColors;
};

const Card = ({ className, variant, color, children, ...props }: CardProps) => {
  const accented = variant === 'accented';
  return (
    <RadixCard
      className={cn(accented ? 'accent-card' : 'rounded-btn', className)}
      variant={accented ? undefined : variant}
      data-accent-color={color}
      {...props}
    >
      {children}
    </RadixCard>
  );
};

export { Card };
export type { CardProps };
